var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 154 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#filter0_i_5524_7483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.204 66.144 87.351-.002l66.146 66.146-10.514 10.514c-13.016-5.634-28.26-3.457-38.387 6.732-10.077 10.138-12.23 25.335-6.677 38.332l-10.568 10.569-11.096-11.096c-13.3 10.153-31.312 10.102-42.247-.833-10.935-10.935-11.041-29.002-.96-42.373L21.204 66.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "M21.204 66.144 87.351-.002l66.146 66.146-10.514 10.514c-13.016-5.634-28.26-3.457-38.387 6.732-10.077 10.138-12.23 25.335-6.677 38.332l-10.568 10.569-11.096-11.096c-13.3 10.153-31.312 10.102-42.247-.833-10.935-10.935-11.041-29.002-.96-42.373L21.204 66.144Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5524_7483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M72.636 51.738c.127 0 .318-.178.572-.534.28-.356.598-.954.954-1.793.178-.381.458-1.03.84-1.945.407-.94.865-2.021 1.374-3.242a369.656 369.656 0 0 0 1.64-3.89 193.005 193.005 0 0 0 1.642-3.89 183.3 183.3 0 0 0 1.374-3.28c.407-.941.687-1.615.84-2.022.33-.814.508-1.398.534-1.755.025-.355-.026-.534-.153-.534h8.32c-.102 0-.14.178-.115.534.026.331.204.916.534 1.755.153.407.42 1.08.802 2.021.381.916.827 1.996 1.335 3.242.51 1.22 1.044 2.505 1.603 3.853.56 1.347 1.094 2.644 1.603 3.89.509 1.22.967 2.301 1.374 3.242.407.94.7 1.614.878 2.021.381.84.75 1.437 1.106 1.793.357.356.624.534.802.534h-8.663c.203-.026.369-.216.496-.572.153-.382.153-.966 0-1.755a4.766 4.766 0 0 0-.229-.953c-.102-.382-.216-.649-.343-.801-.128-.178-.344-.28-.65-.305-.28-.026-.75-.038-1.411-.038H83.13c-.687 0-1.196.025-1.527.076-.33.025-.56.114-.687.267-.127.152-.229.407-.305.763a11.23 11.23 0 0 1-.115.495 7.2 7.2 0 0 1-.076.496c-.178.814-.229 1.399-.153 1.755.102.356.23.547.382.572h-8.014Zm11.487-8.62h4.465c.738 0 1.145-.064 1.221-.19.077-.128.038-.407-.114-.84-.331-.813-.662-1.64-.992-2.479-.331-.864-.65-1.703-.955-2.517a255.65 255.65 0 0 1-.763-2.25 70.032 70.032 0 0 0-.534-1.793h-.076c-.357.94-.726 1.932-1.107 2.975a620.307 620.307 0 0 1-1.069 2.899c-.33.89-.598 1.627-.801 2.212l-.305.839c-.179.407-.242.7-.191.877.05.178.458.267 1.22.267Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5524_7483",
    width: 134.293,
    height: 136.293,
    x: 21.204,
    y: -0.002,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7483"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5524_7483",
    width: 28.859,
    height: 23.885,
    x: 72.636,
    y: 28.854,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7483"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAInactive);
export default __webpack_public_path__ + "static/media/a_inactive.ce01da9469434bb9b73868d47812e32c.svg";
export { ForwardRef as ReactComponent };